import { useState, useEffect, useContext } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import TopNavBar from '../components/navigation/TopNavBar'
import DropdownInput from '../components/inputs/DropdownInput'
import ScheduleInfoModal from '../components/modals/ScheduleInfoModal'
import ReportsModal from '../components/modals/ReportsModal'
import LoadingModal from '../components/modals/LoadingModal'
import DropdownMenu from '../components/menu/DropdownMenu'
import MenuItem from '@mui/material/MenuItem'
import * as Constants from '../utils/constants'
import { UserContext } from '../App'
import { isExpired } from 'react-jwt'
import { ToastContainer, toast } from 'react-toastify'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import ptLocale from '@fullcalendar/core/locales/pt'
import confirmedIcon from '../assets/confirmed.png'
import unconfirmedIcon from '../assets/unconfirmed.png'
import pastIcon from '../assets/past.png'
import arrowDown from '../assets/arrow-down.png'
import arrowDownGrey from '../assets/arrow-down-grey.png'
import strings from '../res/strings'
import '../res/fullCalendarStyles.css'
import 'react-toastify/dist/ReactToastify.css'
import 'bootstrap-icons/font/bootstrap-icons.css'

const SchedulesBO = () => {
    const [schedules, setSchedules] = useState([])
    const [events, setEvents] = useState([])
    const [services, setServices] = useState([])
    const [harborServices, setHarborServices] = useState([])
    const [harbors, setHarbors] = useState([])

    const [selectedHarbor, setSelectedHarbor] = useState(null)
    const [selectedEvent, setSelectedEvent] = useState(null)

    const [docapescaId, setDocapescaId] = useState(null)

    const [showInfoModal, setShowInfoModal] = useState(false)
    const [showReportsModal, setShowReportsModal] = useState(false)

    const [anchorEl, setAnchorEl] = useState(null)
    const open = Boolean(anchorEl)

    const [anchorElReports, setAnchorElReports] = useState(null)
    const openReports = Boolean(anchorElReports)

    const [isLoading, setIsLoading] = useState(true)

    const { loggedUser, setLoggedUser } = useContext(UserContext)
    const navigate = useNavigate()

    useEffect(() => {
        if(loggedUser !== null && loggedUser !== 'refresh') {
            const isTokenExpired = isExpired(loggedUser.jwtToken)

            if(isTokenExpired) {
                setLoggedUser(null)
                navigate('/')
            } else if(loggedUser.role === Constants.Roles.CLIENT) {
                navigate('/')
            } else {
                if(loggedUser.role !== Constants.Roles.ADMINIT) {
                    getUserHarbor()
                } else {
                    getAdminHarbors()
                }

                getDocapescaId()
            }
        } else if (loggedUser === null) {
            navigate('/')
        }
    }, [loggedUser])

    useEffect(() => {
        if(schedules.length > 0 && services.length > 0) {
            schedules.map((schedule) => {
                if(schedule && schedule.scheduleStatusId !== Constants.ScheduleStatus.REJECTED && schedule.scheduleTypeId !== Constants.ScheduleTypes.FACILITIES) {
                    let isPastSchedule = false

                    const today = new Date()
                    let currentDate

                    if(schedule.endDate) {
                        currentDate = new Date(schedule.endDate)
                    } else if(schedule.startDate) {
                        currentDate = new Date(schedule.startDate)
                    } else {
                        currentDate = new Date(schedule.accessFacilitiesStartDate)
                    }

                    if(currentDate >= today) {
                        isPastSchedule = false
                    } else {
                        isPastSchedule = true
                    }

                    const newEvent = {
                        id: schedule.id,
                        title: showServiceTypeText(schedule.scheduleTypeId),
                        start: schedule.startDate,
                        end: schedule.endDate,
                        color: isPastSchedule ? '#EDEDED' : getColorByService(schedule),
                        borderColor: isPastSchedule ? '#EDEDED' : getBorderColorByService(schedule),
                        textColor: isPastSchedule ? '#767676' : getBorderColorByService(schedule),
                        display: 'block',
                        extendedProps: schedule
                    }

                    setEvents(oldArray => [...oldArray, newEvent])
                }
            })
        }
    }, [schedules, services])

    // Auto refresh schedules/events data
    /*useEffect(() => {
        const intervalId = setInterval(() => refreshData(), 60000)
        return () => clearInterval(intervalId)
    }, [])*/

    // Handle get user harbor request
    const getUserHarbor = () => {
        fetch('/api/Backoffice/GetHarbor', {
            method:'GET',
            headers: { 
              'Accept': 'application/json',
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': 'Bearer ' + loggedUser.jwtToken
            }, 
            mode: 'cors'
        }).then(async response => {
            if (response.status === 200) {
                const jsonRes = await response.json()

                const harbor = {
                    value: jsonRes.harborId,
                    label: jsonRes.harborName
                }

                setSelectedHarbor(harbor)

                getHarbors(harbor)
            } else {
                setTimeout(() => {
                    setIsLoading(false)
                    showErrorToast(strings.getUserHarborError)

                    setSelectedHarbor(null)
                }, 1000)
            }

        }).catch((error) => {
            setTimeout(() => {
                setIsLoading(false)
                showErrorToast(error)
                
                setSelectedHarbor(null)
            }, 1000)
        })
    }

    // Handle get harbors
    const getHarbors = (harbor) => {
        fetch('/api/Backoffice/ListHarbors', {
            method:'GET',
            headers: { 
              'Accept': 'application/json',
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': 'Bearer ' + loggedUser.jwtToken
            }, 
            mode: 'cors'
        }).then(async response => {
            if (response.status === 200) {
                const jsonRes = await response.json()

                const arrayHarbors = jsonRes.map((option) => ({ value: option.id, label: option.name }))

                setHarbors(arrayHarbors)

                getServices(harbor)
            } else {
                setTimeout(() => {
                    setIsLoading(false)
                    showErrorToast(strings.getDropdownsError)

                    setHarbors([])
                }, 1000)  
            }
        }).catch((error) => {
            setTimeout(() => {
                setIsLoading(false)
                showErrorToast(error)

                setHarbors([])
            }, 1000)   
        })
    }

    // Handle get harbors
    const getAdminHarbors = () => {
        fetch('/api/Backoffice/ListHarbors', {
            method:'GET',
            headers: { 
              'Accept': 'application/json',
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': 'Bearer ' + loggedUser.jwtToken
            }, 
            mode: 'cors'
        }).then(async response => {
            if (response.status === 200) {
                const jsonRes = await response.json()

                const arrayHarbors = jsonRes.map((option) => ({ value: option.id, label: option.name }))
                const harbor = arrayHarbors.find(harborItem => harborItem.value === 1)

                setHarbors(arrayHarbors)

                setSelectedHarbor(harbor)
                getServices(harbor)
            } else {
                setTimeout(() => {
                    setIsLoading(false)
                    showErrorToast(strings.getDropdownsError)

                    setHarbors([])
                    setSelectedHarbor(null)
                }, 1000)  
            }
        }).catch((error) => {
            setTimeout(() => {
                setIsLoading(false)
                showErrorToast(error)

                setHarbors([])
                setSelectedHarbor(null)
            }, 1000)   
        })
    }

    // Handle get services request
    const getServices = (harbor) => {
        fetch('/api/Schedule/Types', {
            method:'GET',
            headers: { 
              'Accept': 'application/json',
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': 'Bearer ' + loggedUser.jwtToken
            }, 
            mode: 'cors'
        }).then(async response => {
            if (response.status === 200) {
                const jsonRes = await response.json()

                setServices(jsonRes)

                getSchedules(harbor)
            } else {
                setTimeout(() => {
                    setIsLoading(false)
                    showErrorToast(strings.getIntervetionTypesError)

                    setServices([])
                }, 1000)
            }

        }).catch((error) => {
            setTimeout(() => {
                setIsLoading(false)
                showErrorToast(error)
                
                setServices([])
            }, 1000)
        })
    }

    // Handle get schedules request
    const getSchedules = (harbor) => {
        fetch(`/api/Schedule/${harbor.value}/ListByHarborId`, {
            method:'GET',
            headers: { 
              'Accept': 'application/json',
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': 'Bearer ' + loggedUser.jwtToken
            }, 
            mode: 'cors'
        }).then(async response => {
            setTimeout(async () => {
                if (response.status === 200) {
                    const jsonRes = await response.json()
    
                    if(loggedUser.role === Constants.Roles.DEALER) {
                        setSchedules(jsonRes.filter(item => item.entityId === loggedUser.entityId))
                    } else {
                        setSchedules(jsonRes)
                    }
    
                    if(loggedUser.role !== Constants.Roles.ADMINIT) {
                        getSkills(harbor.value)
                    } else {
                        setIsLoading(false)
                    }
                    
                } else {
                    showErrorToast(strings.getSchedulesError)
                    setSchedules([])
                }

            }, 1000)
            
        }).catch((error) => {
            setTimeout(() => {
                setIsLoading(false)
                showErrorToast(error)
                
                setSchedules([])
            }, 1000)
        })
    }

    // Handle get skills by entity id and harbor id
    const getSkills = (harborId) => {
        fetch(`/api/Backoffice/${harborId}/${loggedUser.entityId}/GetScheduleTypesByHarborAndEntity`, {
            method:'GET',
            headers: { 
              'Accept': 'application/json',
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': 'Bearer ' + loggedUser.jwtToken
            }, 
            mode: 'cors'
        }).then(async response => {
            setTimeout(async () => {
                setIsLoading(false)

                if (response.status === 200) {
                    const jsonRes = await response.json()

                    let services = []

                    jsonRes.map((skill) => {
                        services.push(skill.name)
                    })

                    setHarborServices(services)
                } else {
                    showErrorToast(strings.getSkillsError)
                    setHarborServices([])
                }

            }, 1000)
        }).catch((error) => {
            setTimeout(() => {
                setIsLoading(false)
                showErrorToast(error)
                
                setHarborServices([])
            }, 1000)
        })
    }

    // Handle get Docapesca entity id request
    const getDocapescaId = () => {
        fetch(`/api/Backoffice/GetDocapescaId`, {
            method:'GET',
            headers: { 
              'Accept': 'application/json',
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': 'Bearer ' + loggedUser.jwtToken
            }, 
            mode: 'cors'
        }).then(async response => {
            if (response.status === 200) {
                const jsonRes = await response.json()

                setDocapescaId(jsonRes)
            } else {
                showErrorToast(strings.getDocapescaIdError)
                
                setDocapescaId(null)
            }
        }).catch((error) => {
            setTimeout(() => {
                setIsLoading(false)
                showErrorToast(error)
                
                setDocapescaId(null)
            }, 1000)
        })
    }

    // Handles date formatting
    const formatDate = (date) => {
        const day = date.getDate()
        const month = date.getMonth() + 1
        const year = date.getFullYear()
        return `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`
    }

    // Handles time formatting
    const formatTime = (timeStamp) => {
        const date = new Date(timeStamp)
        const hours = date.getHours()
        const minutes = date.getMinutes()
        return `${hours < 10 ? '0' + hours : hours}:${minutes < 10 ? '0' + minutes : minutes}`
    }

    // Handles the generation of the monthly report
    const exportToExcel = () => {
        setIsLoading(true)

        const currentDate = new Date();
        const firstDayMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1)
        const lastDayMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0)

        const start = formatDate(firstDayMonth)
        const end = formatDate(lastDayMonth)
        const monthName = Constants.MONTHS[currentDate.getUTCMonth()]

        fetch(`/api/Schedule/ExportToExcel?harborId=${selectedHarbor && selectedHarbor.value}&startDate=${start}&endDate=${end}`, {
            method:'GET',
            headers: { 
              'Accept': 'application/json',
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': 'Bearer ' + loggedUser.jwtToken
            }, 
            mode: 'cors'
        }).then(async response => {
            setTimeout(async () => {
                setIsLoading(false)

                if (response.status === 200) {
                    const filename = `Relatório de agendamento mensal (${monthName}).xlsx`
                    
                    const blob = await response.blob()
                    
                    const link = document.createElement('a')
                    link.href = window.URL.createObjectURL(blob)
                    link.download = filename
                    
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)

                    setShowReportsModal(false)
                } else if(response.status === 404) {
                    showErrorToast(strings.noSchedulesFoundError)
                } else {
                    showErrorToast(strings.exportToExcelError)
                }
                
            }, 1000)
        }).catch((error) => {
            setTimeout(() => {
                setIsLoading(false)
                showErrorToast(error)
            }, 1000)
        })
    }

    // Check all the dates and return first date time
    const getStartTime = (schedule) => {
        if(schedule.scheduleTypeId === Constants.ScheduleTypes.FAIRING || schedule.scheduleTypeId === Constants.ScheduleTypes.FAIRINGENERGY) {
            let datesArray = []

            if(schedule.dryStartDate) {
                datesArray.push(new Date(schedule.dryStartDate))
            }

            if(schedule.swimStartDate) {
                datesArray.push(new Date(schedule.swimStartDate))
            }

            if(schedule.lineChangeStartDate) {
                datesArray.push(new Date(schedule.lineChangeStartDate))
            }

            if(schedule.supplyPersonnelStartDate) {
                datesArray.push(new Date(schedule.supplyPersonnelStartDate))
            }

            if(schedule.rippingStartDate) {
                datesArray.push(new Date(schedule.rippingStartDate))
            }

            const dates = datesArray.map(date => date.getTime())

            const minTimestamp = Math.min(...dates)
            const firstDate = new Date(minTimestamp)

            if(minTimestamp === Infinity) {
                return ''
            } else {
                return formatTime(firstDate) + ' | '
            } 
        }
    }

    // Handles the event UI
    const renderEventContent = (eventInfo) => {
        return (
          <div className='fc-event-title px-1 h-6 flex flex-row items-center'>
            <p className='font-semibold px-1'>{(eventInfo.event.extendedProps.scheduleTypeId === Constants.ScheduleTypes.FAIRINGENERGY || eventInfo.event.extendedProps.scheduleTypeId === Constants.ScheduleTypes.MOORINGENERGY || eventInfo.event.extendedProps.scheduleTypeId === Constants.ScheduleTypes.ENERGY) && !eventInfo.event.extendedProps.powerInitialReading && eventInfo.event.extendedProps.scheduleStatusId === Constants.ScheduleStatus.CONFIRMED ? '*' : null} {getStartTime(eventInfo.event.extendedProps)}{eventInfo.event.title}</p>
          </div>
        )
    }

    // Handles the event click - show informations popup
    const onEventClick = (eventInfo) => {
        setSelectedEvent(eventInfo.event)
        setShowInfoModal(true)
    }

    // Handles open new schedule dropdown menu
    const openDropdownMenu = (event) => {
        setAnchorEl(event.currentTarget)
    }

    // Handles close new schedule dropdown menu
    const closeDropdownMenu = () => {
        setAnchorEl(null)
    }

    // Handle changes in harbor dropdown
    const onChangeSelectedHarbor = (item) => {
        setSelectedHarbor(item)
        setIsLoading(true)
        setSchedules([])
        setEvents([])
        getSchedules(item)
    }   

    // Navigate to new schedule fairing
    const onClickFairing = () => {
        setAnchorEl(null)
        navigate('/new-schedule', {
            state: {
                service: Constants.ScheduleTypes.FAIRING
            }}
        )
    }

    // Navigate to new schedule fairing + electricity supply
    const onClickFairingEnergy = () => {
        setAnchorEl(null)
        navigate('/new-schedule', {
            state: {
                service: Constants.ScheduleTypes.FAIRINGENERGY
            }}
        )
    }

    // Navigate to new schedule mooring
    const onClickMooring = () => {
        setAnchorEl(null)
        navigate('/new-schedule', {
            state: {
                service: Constants.ScheduleTypes.MOORING
            }}
        )
    }

    // Navigate to new schedule mooring + electricity supply
    const onClickMooringEnergy = () => {
        setAnchorEl(null)
        navigate('/new-schedule', {
            state: {
                service: Constants.ScheduleTypes.MOORINGENERGY
            }}
        )
    }

    // Navigate to new schedule electricity supply
    const onClickElectricitySupply = () => {
        setAnchorEl(null)
        navigate('/new-schedule', {
            state: {
                service: Constants.ScheduleTypes.ENERGY
            }}
        )
    }

    // Navigate to new schedule access to facilities
    const onClickAccessToFacilities = () => {
        setAnchorEl(null)
        navigate('/new-schedule', {
            state: {
                service: Constants.ScheduleTypes.FACILITIES
            }}
        )
    }

    // Check if given skill exists in user skills
    const checkSkillByName = (skills, skill) => {
        if (skills.includes(skill)) {
            return true
        } else {
            return false
        }
    }

    // Handle reject schedule
    const rejectSchedule = () => {
        setShowInfoModal(false)
        setIsLoading(true)

        // Reject schedule
        fetch(`/api/Schedule/${selectedEvent.id}/Respond?response=false`, {
            method:'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': 'Bearer ' + loggedUser.jwtToken
            }, 
            mode: 'cors'
        }).then(async response => {
            setTimeout(async () => {
                setIsLoading(false)
                
                if (response.status === 200) {
                    setIsLoading(true)

                    setSchedules([])
                    setEvents([])
                    
                    getSchedules(selectedHarbor)
                } else {
                    showErrorToast(strings.rejectScheduleError)
                }
            }, 1000)

        }).catch((error) => {
            setTimeout(() => {
                setIsLoading(false)
                showErrorToast(error)
            }, 1000)   
        })
    }

    // Handle accept schedule
    const acceptSchedule = () => {
        setShowInfoModal(false)
        setIsLoading(true)

        // Accept schedule
        fetch(`/api/Schedule/${selectedEvent.id}/Respond?response=true`, {
            method:'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': 'Bearer ' + loggedUser.jwtToken
            }, 
            mode: 'cors'
        }).then(async response => {
            setTimeout(async () => {
                setIsLoading(false)
                
                if (response.status === 200) {
                    setIsLoading(true)

                    setSchedules([])
                    setEvents([])

                    getSchedules(selectedHarbor)
                } else {
                    showErrorToast(strings.acceptScheduleError)
                }
            }, 1000)

        }).catch((error) => {
            setTimeout(() => {
                setIsLoading(false)
                showErrorToast(error)
            }, 1000)   
        })
    }

    // Handle cancel reschedule
    const cancelSchedule = () => {
        setShowInfoModal(false)
        setIsLoading(true)

        // Cancel schedule
        fetch(`/api/Schedule/${selectedEvent && selectedEvent.id}/Delete`, {
            method:'DELETE',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': 'Bearer ' + loggedUser.jwtToken
            }, 
            mode: 'cors'
        }).then(async response => {
            setTimeout(async () => {
                setIsLoading(false)
                
                if (response.status === 200) {
                    setIsLoading(true)

                    setSchedules([])
                    setEvents([])

                    getSchedules(selectedHarbor)
                } else {
                    showErrorToast(strings.cancelScheduleError)
                }
            }, 1000)

        }).catch((error) => {
            setTimeout(() => {
                setIsLoading(false)
                showErrorToast(error)
            }, 1000)   
        })
    }

    // Handles open actions dropdown menu
    const openReportsDropdownMenu = (event, row) => {
        setAnchorElReports(event.currentTarget)
    }

    // Handles close actions dropdown menu
    const closeReportsDropdownMenu = () => {
        setAnchorElReports(null)
    }

    // Handles the generation of the monthly report
    const onClickMonthlyReport = () => {
        setAnchorElReports(null)
        exportToExcel()
    }

    // Open the report between dates popup
    const onClickBetweenDatesReport = () => {
        setAnchorElReports(null)
        setShowReportsModal(true)
    }

    // Check the service type and show matching text
    const showServiceTypeText = (scheduleTypeId) => {
        const serviceType = services && services.find((service) => service.id === scheduleTypeId)
        return serviceType && serviceType.name
    }

    // Check the service type and return corresponding color
    const getColorByService = (schedule) => {
        switch(schedule.scheduleTypeId) {
            case Constants.ScheduleTypes.FAIRING: return schedule.scheduleStatusId === Constants.ScheduleStatus.CONFIRMED ? '#C4281C' : 'rgba(196, 40, 28, 0.10)'

            case Constants.ScheduleTypes.FAIRINGENERGY: return schedule.scheduleStatusId === Constants.ScheduleStatus.CONFIRMED ? '#C4281C' : 'rgba(196, 40, 28, 0.10)'

            case Constants.ScheduleTypes.MOORING: return schedule.scheduleStatusId === Constants.ScheduleStatus.CONFIRMED ? '#397D49' : 'rgba(57, 125, 73, 0.10)'

            case Constants.ScheduleTypes.MOORINGENERGY: return schedule.scheduleStatusId === Constants.ScheduleStatus.CONFIRMED ? '#397D49' : 'rgba(57, 125, 73, 0.10)'

            case Constants.ScheduleTypes.ENERGY: return schedule.scheduleStatusId === Constants.ScheduleStatus.CONFIRMED ? '#8231A4' : 'rgba(65, 83, 175, 0.10)'

            case Constants.ScheduleTypes.FACILITIES: return schedule.scheduleStatusId === Constants.ScheduleStatus.CONFIRMED ? '#4153AF' : 'rgba(130, 49, 164, 0.10)'

            default: return '#FFF'
        }
        
    }

    // Check the service type and return corresponding border color
    const getBorderColorByService = (schedule) => {
        switch(schedule.scheduleTypeId) {
            case Constants.ScheduleTypes.FAIRING: return schedule.scheduleStatusId === Constants.ScheduleStatus.CONFIRMED ? '#FFF' : '#C4281C'

            case Constants.ScheduleTypes.FAIRINGENERGY: return schedule.scheduleStatusId === Constants.ScheduleStatus.CONFIRMED ? '#FFF' : '#C4281C'

            case Constants.ScheduleTypes.MOORING: return schedule.scheduleStatusId === Constants.ScheduleStatus.CONFIRMED ? '#FFF' : '#397D49'

            case Constants.ScheduleTypes.MOORINGENERGY: return schedule.scheduleStatusId === Constants.ScheduleStatus.CONFIRMED ? '#FFF' : '#397D49'

            case Constants.ScheduleTypes.ENERGY: return schedule.scheduleStatusId === Constants.ScheduleStatus.CONFIRMED ? '#FFF' : '#8231A4'

            case Constants.ScheduleTypes.FACILITIES: return schedule.scheduleStatusId === Constants.ScheduleStatus.CONFIRMED ? '#FFF' : '#4153AF'

            default: return '#FFF'
        }
        
    }

    // Handle refreshing calendar schedules
    const refreshCalendar = () => {
        setSchedules([])
        setEvents([])

        setIsLoading(true)

        getSchedules(selectedHarbor)
    }

    // Handle refreshing data
    /*const refreshData = () => {
        if(loggedUser !== null && loggedUser !== 'refresh') {
            if(loggedUser.role !== Constants.Roles.ADMINIT) {
                getUserHarbor()
            } else {
                getAdminHarbors()
            }
        }
    }*/

    // Calendar refresh button
    const customButtons = {
        refreshButton: {
            text: 'Refresh',
            icon: 'bi bi-arrow-clockwise',
            click: () => refreshCalendar(),
        },
    }
    
    // Handle show error toast
    const showErrorToast = (error) => {
        toast.error(error, {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: 'colored'
        })
    }

    return (
        <>
            <TopNavBar />

            <div className='h-14 border-b border-accent flex flex-row items-center justify-between px-[12.5rem]'>
                <div className='flex flex-row space-x-9'>
                    <p className='font-montserrat font-semibold text-accent'>{strings.schedules}</p>
                    { loggedUser && (loggedUser.role === Constants.Roles.PORTADMIN || loggedUser.role === Constants.Roles.ADMINIT) ?
                        <>
                            <Link to='/backoffice-users' className='font-montserrat text-neutral5 cursor-pointer'>{strings.userManagement}</Link>
                            { loggedUser.role === Constants.Roles.ADMINIT ? 
                                <Link to='/backoffice-entities' className='font-montserrat text-neutral5 cursor-pointer'>{strings.entityManagement}</Link>
                            : null }
                        </>   
                    : null }
                   
                </div>

                { loggedUser && loggedUser.role === Constants.Roles.ADMINIT ? 
                    <Link to='/new-schedule' className='flex flex-row items-center rounded-[6.25rem] h-10 px-6 bg-accent'>
                        <p className='font-montserrat font-semibold text-white'>{strings.newSchedule}</p>
                    </Link>
                :   <div className='flex flex-row items-center'>
                        <button onClick={openDropdownMenu} className='flex flex-row items-center rounded-[6.25rem] h-10 ps-6 pe-4 bg-accent space-x-2.5'>
                            <p className='font-montserrat font-semibold text-white'>{strings.newSchedule}</p>
                            <img className='h-5 w-5' src={arrowDown}  alt='Expandir menu' />
                        </button>

                        <DropdownMenu
                            anchorEl={anchorEl}
                            open={open}
                            onClose={closeDropdownMenu}
                        >
                            { checkSkillByName(harborServices, Constants.SkillNames.fairing) || (loggedUser && loggedUser.role === Constants.Roles.ADMINIT) ?
                                <MenuItem onClick={onClickFairing} disableRipple>{strings.fairing}</MenuItem>
                            : null }

                            { checkSkillByName(harborServices, Constants.SkillNames.fairingEnergy) || (loggedUser && loggedUser.role === Constants.Roles.ADMINIT) ?
                                <MenuItem onClick={onClickFairingEnergy} disableRipple>{strings.fairing} + {strings.energy}</MenuItem>
                            : null }

                            { checkSkillByName(harborServices, Constants.SkillNames.mooring) || (loggedUser && loggedUser.role === Constants.Roles.ADMINIT) ?
                                <MenuItem onClick={onClickMooring} disableRipple>{strings.mooring}</MenuItem>
                            : null }
                            
                            { checkSkillByName(harborServices, Constants.SkillNames.mooringEnergy) || (loggedUser && loggedUser.role === Constants.Roles.ADMINIT) ?
                                <MenuItem onClick={onClickMooringEnergy} disableRipple>{strings.mooring} + {strings.energy}</MenuItem>
                            : null }

                            { checkSkillByName(harborServices, Constants.SkillNames.electricitySupply) || (loggedUser && loggedUser.role === Constants.Roles.ADMINIT) ?
                                <MenuItem onClick={onClickElectricitySupply} disableRipple>{strings.electricitySupply}</MenuItem>
                            : null }

                            { checkSkillByName(harborServices, Constants.SkillNames.accessToFacilities) || (loggedUser && loggedUser.role === Constants.Roles.ADMINIT) ?
                                <MenuItem onClick={onClickAccessToFacilities} disableRipple>{strings.accessToFacilities}</MenuItem>
                            : null }

                        </DropdownMenu>
                    </div>
                }
                
            </div>

            { isLoading ?
                <div className='h-screen'>
                    <LoadingModal />
                </div>
            :   <>
                    <div className='flex flex-row ps-[12.5rem] my-8 w-1/2 space-x-6'>
                        <div className='flex flex-col flex-1 z-10'>
                            <p className='font-montserrat font-semibold text-sm' style={{ color: loggedUser && loggedUser.role === Constants.Roles.ADMINIT ? '#002F53' : 'rgba(0, 46, 82, 0.5)'}}>{strings.harbor}</p>
                            <DropdownInput 
                                options={harbors}
                                value={selectedHarbor}
                                onChange={onChangeSelectedHarbor}
                                disabled={loggedUser && loggedUser.role === Constants.Roles.ADMINIT ? false : true}
                            />
                        </div>

                        <div className='flex flex-1 flex-col'>
                            <p className='font-montserrat font-semibold text-sm text-navy'>{strings.reports}</p>
                            <button onClick={openReportsDropdownMenu} className='flex flex-row items-center justify-between rounded h-10 ps-3 pe-4 mt-1.5 border border-neutral5'>
                                <p className='font-montserrat text-neutral5'>{strings.select}</p>
                                <img className='h-6 w-6' src={arrowDownGrey}  alt='Expandir menu' />
                            </button>

                            <DropdownMenu
                                anchorEl={anchorElReports}
                                open={openReports}
                                onClose={closeReportsDropdownMenu}
                                width={343}
                            >
                                <MenuItem onClick={onClickMonthlyReport} disableRipple>{strings.generateMonthlyReport}</MenuItem>
                                <MenuItem onClick={onClickBetweenDatesReport} disableRipple>{strings.generateReportBetweenDates}</MenuItem>
                            </DropdownMenu>
                        </div>
                    </div>

                    <div className='px-[12.5rem]'>
                        <FullCalendar
                            plugins={[ dayGridPlugin ]}
                            initialView='dayGridMonth'
                            dayHeaderFormat={{ weekday: 'long' }}
                            headerToolbar = {{
                                left: 'prev,next,today',
                                center: 'title',
                                right: 'dayGridMonth,dayGridWeek,dayGridDay refreshButton'
                            }}
                            locale={ptLocale}
                            events={events}
                            eventContent={renderEventContent}
                            eventClick={onEventClick}
                            stickyHeaderDates={true}
                            customButtons={customButtons}
                            themeSystem='bootstrap5'
                        />
                    </div>

                    <div className='flex flex-row justify-end mt-6 mb-20 pe-[12.5rem] space-x-[1.875rem]'>
                        <div className='flex flex-row items-center space-x-2'>
                            <img className='h-[1.063rem] w-[1.063rem]' src={confirmedIcon} alt='Confirmado'/>
                            <p className='font-montserrat'>{strings.confirmed}</p>
                        </div>

                        <div className='flex flex-row items-center space-x-2'>
                            <img className='h-[1.063rem] w-[1.063rem]' src={unconfirmedIcon} alt='Por confirmar'/>
                            <p className='font-montserrat'>{strings.unconfirmed}</p>
                        </div>

                        <div className='flex flex-row items-center space-x-2'>
                            <img className='h-[1.063rem] w-[1.063rem]' src={pastIcon} alt='Passados'/>
                            <p className='font-montserrat'>{strings.past2}</p>
                        </div>
                    </div>
                </>
            }           
            
            <ScheduleInfoModal 
                open={showInfoModal}
                onClose={() => setShowInfoModal(false)}
                item={selectedEvent && selectedEvent.extendedProps}
                onClickReject={rejectSchedule}
                onClickDetails={() => navigate(`/schedule-details/${selectedEvent && selectedEvent.id}`)}
                onClickSuggest={() => navigate(`/suggest-schedule/${selectedEvent && selectedEvent.id}`)}
                onClickAccept={acceptSchedule}
                onClickCancel={cancelSchedule}
                services={services}
                docapescaId={docapescaId}
                loggedUser={loggedUser}
            />

            <ReportsModal
                open={showReportsModal}
                onClose={() => setShowReportsModal(false)}
                jwtToken={loggedUser && loggedUser.jwtToken}
                setIsLoading={() => setIsLoading(true)}
                setIsNotLoading={() => setIsLoading(false)}
                showErrorToast={(error) => showErrorToast(error)}
                harborId={selectedHarbor && selectedHarbor.value}
            />

            <ToastContainer /> 
        </>
    )
}

export default SchedulesBO